import { Controller, ActionEvent } from "@hotwired/stimulus";

export default class StatusSelectController extends Controller {
  static targets = ["config"];
  declare configTarget: HTMLScriptElement;

  config: { status: string; } = { status: "" };

  connect() {
    this.config = JSON.parse(this.configTarget.innerText) as { status: string; }
    this.dispatch("init", { detail: { status: this.config.status } });
  }

  onChange(evt: ActionEvent) {
    this.dispatch("change", { detail: { status: evt.params.status as string } });
  }
}
